var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebar3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_75",
    "data-name": "Rectangle 75",
    width: 18,
    height: 18,
    transform: "translate(20 106)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_13",
    "data-name": "Mask Group 13",
    transform: "translate(-20 -106)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(18.875 104.875)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M18,16.875H2.25A1.125,1.125,0,0,1,1.125,15.75V4.5A1.125,1.125,0,0,1,2.25,3.375H18A1.125,1.125,0,0,1,19.125,4.5V15.75A1.125,1.125,0,0,1,18,16.875ZM2.25,4.5V15.75H18V4.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M5.063,14.231a.45.45,0,0,1-.45-.45V6.469a.45.45,0,1,1,.9,0v7.312A.45.45,0,0,1,5.063,14.231Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M8.392,14.231a.45.45,0,0,1-.45-.45V6.469a.45.45,0,1,1,.9,0v7.312A.45.45,0,0,1,8.392,14.231Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M11.813,14.231a.45.45,0,0,1-.45-.45V6.469a.45.45,0,1,1,.9,0v7.312a.45.45,0,0,1-.45.45Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M15.188,14.231a.45.45,0,0,1-.45-.45V6.469a.45.45,0,1,1,.9,0v7.312a.45.45,0,0,1-.45.45Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebar3);
export default __webpack_public_path__ + "static/media/sidebar3.815be6fd538fe808ccf457103292fe61.svg";
export { ForwardRef as ReactComponent };